import * as React from 'react';
import classNames from 'classnames';

import { Button } from '@canvas-logic/clp-shared-ui';

import styles from './ModalCloseButton.module.css';

interface IProps {
  variant?: 'default' | 'fab';
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

export const ModalCloseButton = ({ variant = 'default', onClick, className }: IProps) => {
  return (
    <Button
      className={classNames(
        styles.button,
        {
          [styles.fab]: variant === 'fab',
        },
        className,
      )}
      variant={variant === 'default' ? 'ghost' : 'secondary'}
      iconStart="close"
      onClick={onClick}
    />
  );
};
